export default {
  home: {
    status: {
      display: '',
    },
  },
};
